<script lang="ts">
	import {
		openTokenDepositModal,
		openTokenWithdrawModal
	} from '$lib/home/userInteract/userInteract';
	import { getTokenLogo } from '$lib/tokensConfig';
	import Tooltip from '$lib/tooltip/Tooltip.svelte';
	import type { TokenType, TokenUI } from '$lib/types/tokens';

	export let token: TokenUI;
	export let balance: string;
	export let scwAddress: string;
	export let type: TokenType = 'standard';
</script>

<div class="flex justify-between items-center bg-fx-grey-800 p-2 rounded-lg squircle-lg w-full">
	<div class="flex gap-1">
		<a
			href={`https://optimistic.etherscan.io/token/${token.address}?a=${scwAddress}`}
			target="_blank"
			rel="noreferrer"
		>
			<img
				src={getTokenLogo(token.symbol)}
				loading="lazy"
				alt="token"
				class={`w-7 h-7 ${token.allowed ? '' : 'grayscale'}`}
			/>
		</a>
		<div>
			<p class="text-sm text-fx-grey-100 font-medium">{token.symbol}</p>
			<div class="flex gap-1">
				<p class="text-fx-grey-300 text-xs font-normal">Balance:</p>
				<p
					class={`text-fx-grey-100 text-xs font-medium ${token.allowed ? '' : 'text-fx-grey-300'}`}
				>
					{balance}
				</p>
			</div>
		</div>
	</div>

	{#if token.allowed}
		<Tooltip
			header={`Deposit or withdraw ${token.symbol}`}
			title={`Click to deposit or withdraw ${token.symbol}`}
		>
			<button
				on:click={() => {
					openTokenDepositModal(token.symbol);
				}}
			>
				<img
					src={'new_sc_wallet/up_down_arrow.svg'}
					loading="lazy"
					alt="new_sc_wallet/up_down_arrow.svg"
					class={`${token.allowed ? '' : 'grayscale'}`}
				/>
			</button>
		</Tooltip>
	{:else}
		<Tooltip
			header={`${token.symbol} deposit/withdraw disabled`}
			title={`You can enable ${token.symbol} deposit/withdraw by clicking ${
				type == 'stable'
					? '"Auto swap stables during trading"'
					: '"Auto swap Non stables during trading"'
			} in the config section`}
		>
			<button
				on:click={() => {
					// openTokenDepositModal(token.symbol);
					openTokenWithdrawModal(token.symbol);
				}}
				><img
					src={'new_sc_wallet/up_down_arrow.svg'}
					loading="lazy"
					alt="new_sc_wallet/up_down_arrow.svg"
					class={`${token.allowed ? '' : 'grayscale'}`}
				/></button
			>
		</Tooltip>
	{/if}
</div>
